<template>
  <div
    :id="id"
    :class="['hs-overlay hidden fixed top-0 end-0 transition-all duration-300 h-full w-full bg-white border-s border-gray-400 dark:bg-neutral-800 dark:border-neutral-700', sizes[size]]"
    role="dialog"
    tabindex="-1"
  >
    <div class="flex flex-col h-full">
      <div class="flex justify-between items-center px-6 py-4 bg-gray-100 border-b border-gray-100 dark:border-neutral-700">
        <h3 class="text-base font-semibold text-gray-800">{{ title }}</h3>
        <p class="text-xs text-gray-600 mt-0.5">{{ subTitle }}</p>
        <button
          v-if="props.showClose"
          type="button"
          class="cursor-pointer size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
          aria-label="Close"
          @click="closeModal(id)"
        >
          <XMarkIcon />
        </button>
      </div>
      <div class="p-4 overflow-y-auto overflow-x-visible flex-1">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { closeModal } from '@/modules/Core/usings/generales.js'
import { type PropType } from 'vue'
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ""
  },
  subTitle: {
    type: String,
    default: ""
  },
  size: {
    type: String as PropType<'sm' | 'md' | 'lg'>,
    default: "sm"
  },
  showClose: {
    type: Boolean,
    required: false,
    default: true
  },
  fncOnClose:{
    type: Function,
    default: null
  }
})
const { id } = props
const sizes = {
  sm: "w-[80vw] sm:max-w-lg",
  md: "w-[80vw] md:max-w-2xl",
  lg: "w-[80vw] lg:max-w-6xl",
  xl: "w-[80vw] xl:max-w-[80vw]"
}
</script>
